import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {

  gsap.utils.toArray(".gs-move").forEach((el) => {
    gsap.from(el, {
      xPercent: -15,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        scrub: 2.2,

        start: "top bottom",
        end: "top center",

        invalidateOnRefresh: true,
      }
    });
  });

 (() => {
  const containers = document.querySelectorAll('.gs-from-bottom');

  containers.forEach((container) => {
    [...container.children].forEach((child) => {
      const rect = child.getBoundingClientRect();
      const isAlreadyVisible = rect.bottom > 0 && rect.top < window.innerHeight;

      // Element (or part of it) is already visible when the page loads —
      // keep it visible as-is, don't animate it in/out.
      if (isAlreadyVisible) {
        gsap.set(child, { clearProps: "opacity,transform" });
        return;
      }

      gsap.from(child, {
        opacity: 0,
        y: 50,
        ease: "none",

        scrollTrigger: {
          trigger: child,
          start: "top 90%",
          end: "top 50%",
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    });
  });
})();


  (() => {
    const elements = document.querySelectorAll('.underline-reveal');
    if (!elements.length) return;

    elements.forEach(el => {
      gsap.to(el, {
        maskSize: "100% 100%",
        WebkitMaskSize: "100% 100%",
        ease: "none",

        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          end: "top 40%",
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    });
  })();






  (() => {
    const elements = document.querySelectorAll('.js-reval');
    if (!elements.length) return;

    elements.forEach(el => {
      // 🔹 zapisz oryginalny tekst
      const originalText = el.textContent;

      // 🔹 wrap tylko raz
      if (!el.querySelector('.char')) {
        el.innerHTML = originalText.replace(/\S/g, "<span class='char'>$&</span>");
      }

      const chars = el.querySelectorAll('.char');

      // 🔹 animacja
      gsap.fromTo(chars,
        {
          y: -40,
          opacity: 0,
          scaleY: -1
        },
        {
          y: 0,
          opacity: 1,
          scaleY: 1,
          stagger: 0.015,
          duration: 1.9,
          ease: "elastic.out(1, 0.7)",

          scrollTrigger: {
            trigger: el,
            start: "top 50%", // 🔥 połowa ekranu
            toggleActions: "play none none none", // tylko raz
            once: true
          }
        }
      );
    });
  })();




  (() => {
    const container = document.querySelector('.js-tags');
    if (!container) return;

    const items = container.querySelectorAll('.tag-anim');
    if (!items.length) return;

    gsap.from(items, {
      opacity: 0,
      y: 20,
      scale: 0.9,
      ease: "power2.out",
      stagger: 0.08, // 🔥 kluczowy efekt "jeden po drugim"

      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        toggleActions: "play none none none",
      }
    });
  })();




  (() => {
    const rows = document.querySelectorAll(".js-row");
    if (!rows.length) return;

    rows.forEach((row) => {
      const left = row.querySelector(".js-left");
      const right = row.querySelector(".js-right");

      if (!left || !right) return;

      // 🔹 start state
      gsap.set(left, {
        x: -40,
        opacity: 0
      });

      gsap.set(right, {
        x: 40,
        opacity: 0
      });

      // 🔥 animacja scrollowa
      gsap.to(left, {
        x: 0,
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: row,
          start: "top 85%",
          end: "top 50%",
          scrub: true
        }
      });

      gsap.to(right, {
        x: 0,
        opacity: 1,
        ease: "none",
        scrollTrigger: {
          trigger: row,
          start: "top 85%",
          end: "top 40%",
          scrub: true
        }
      });
    });
  })();






  window.afterLoadAnims = () => {
    const tl = gsap.timeline();
    tl.from(document.querySelector("#topbar-logo"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, 0)

    tl.from(document.querySelector("#slogan"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, '-=1.4')

    tl.from(document.querySelector("#topbar-button"), {
      duration: 1.6,
      y: 40,
      autoAlpha: 0,
      ease: 'elastic.out(1, .8)',
    }, '-=1.4')
  }
});
